import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";
import { update_fields, update_positions } from 'admin_resources';

// Connects to data-controller="drag-drop"
export default class extends Controller {
  connect() {
    this.sortable = Sortable.create( this.element, {
      handle: 'tbody',
      onEnd: this.end.bind( this )
    } );
  }

  end( event ) {
    update_positions( event.target );
    update_fields();
  }
}
